// Labels every team profile shares, Swedish: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: 'Personuppgifter',
    rows: {
      name: 'Namn',
      position: 'Befattning',
      birthdate: 'Födelsedatum',
      nationality: 'Nationalitet',
      maritalStatus: 'Civilstånd',
      location: 'Ort',
      languages: 'Språk',
      programmingLanguages: 'Programmeringsspråk',
      certifications: 'Certifieringar',
      publications: 'Publikationer',
      links: 'Webbplats'
    }
  },
  education: {
    title: 'Utbildning'
  },
  skills: {
    title: 'Specialistkompetenser'
  },
  experience: {
    title: 'Projekt och uppdrag',
    techLabel: 'Tekniker'
  },
  downloads: {
    title: 'Ladda ner profil',
    deLabel: 'Ladda ner profilen på tyska',
    deDescription: 'PDF på tyska',
    enLabel: 'Ladda ner CV på engelska',
    enDescription: 'PDF på engelska'
  },
  cta: {
    title: 'Kontakt',
    button: 'Ta kontakt'
  },
  pdf: {
    title: 'Profil',
    personalSection: 'Personuppgifter',
    educationSection: 'Utbildning',
    experienceSection: 'Projekt och uppdrag',
    skillsLabel: 'Kompetenser'
  }
};
